import * as service from './service'
export default {
  namespace: 'MyVehicle',
  state: {
    transports: [],
    currSelected: {}
  },
  effects: {
    * list ({ payload }, { call, put }) {
      const res = yield call(service.list, payload)
      const { transports } = res.data.data
      const currSelected = transports.find(item => item.selected)
      yield put({
        type: 'save',
        payload: {
          transports,
          currSelected
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
